import { render } from "./users-restriction.vue?vue&type=template&id=5a0950ae&scoped=true"
import script from "./users-restriction.vue?vue&type=script&setup=true&lang=js"
export * from "./users-restriction.vue?vue&type=script&setup=true&lang=js"

import "./users-restriction.vue?vue&type=style&index=0&id=5a0950ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0950ae"],['__file',"src/views/administration/users/users-restriction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a0950ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a0950ae', __exports__)) {
    api.reload('5a0950ae', __exports__)
  }
  
  module.hot.accept("./users-restriction.vue?vue&type=template&id=5a0950ae&scoped=true", () => {
    api.rerender('5a0950ae', render)
  })

}


export default __exports__